import React from 'react';
import PropTypes from 'prop-types';
import { StyledWrap, StyledContent, StyledBadge } from './styled';

const ComingSoon = ({ children, label }) => (
  <StyledWrap>
    <StyledContent>{children}</StyledContent>
    <StyledBadge>{label}</StyledBadge>
  </StyledWrap>
);

ComingSoon.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
};

ComingSoon.defaultProps = {
  label: 'Coming soon',
};

export default ComingSoon;
